'use client';

import { Container, Form } from '@mv/web-ui';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import { useI18n } from '@/modules/i18n/useI18n';
import { useDataTags } from '@/modules/tracking/analytics/useDataTags';
import RichHeading from '@/payload/components/RichHeading/RichHeading';
import RichText from '@/payload/components/RichText/RichText';
import type { HeroWithSearchBlock as Props } from '@/payload/types';
import styles from './HeroWithSearch.module.scss';

export interface SearchFormValues {
	query: string;
}

export default function Component(props: Props) {
	const { title, subtitle, placeholder, searchQuery, id, blockType } = props;
	const { blockRef, labelRef } = useDataTags(blockType, id);
	const { locale } = useI18n();
	const router = useRouter();

	const {
		handleSubmit,
		formState: { errors },
		control,
	} = useForm<SearchFormValues>({
		values: {
			query: searchQuery ?? '',
		},
	});

	const search = (data: SearchFormValues) => {
		router.push(`/${locale}/search?query=${data.query}`);
	};

	const handleKeyboardEvent = (e: KeyboardEvent) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleSubmit(search)();
		}
	};
	return (
		<div data-component="HeroWithSearchBlock" ref={blockRef} id="search" className={styles.heroWithSearch}>
			<Container>
				<div className={styles.title}>
					<RichHeading ref={labelRef} content={title} options={{ tag: 'h1' }} />
				</div>

				{subtitle && <div className={styles.subtitle}>{<RichText content={subtitle} />}</div>}

				<div className={styles.search}>
					<Form.Root control={control} errors={errors} submit={handleSubmit(search)}>
						<Form.Field name="query">
							<Form.Search placeholder={placeholder} onKeyDown={handleKeyboardEvent} />
						</Form.Field>
					</Form.Root>
				</div>
			</Container>
		</div>
	);
}
